import { GET_INFO_OF_CHILD } from "../../../../enums/Request/request.types";

export const addInfoOfChildAction = (data) => {
    return {
        type: GET_INFO_OF_CHILD,
        payload: data,
    };
};
